export default __webpack_public_path__ + "images/73dc642c068cd75a9754ed2aab813a1f.png";